import React from "react";
import {
    Snackbar,
    Alert as MuiAlert,
    AlertProps,
    styled,
    AlertColor,
} from "@mui/material";
import { closeMessage } from "../../../reducers/common";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

const Alert = React.forwardRef<HTMLInputElement, AlertProps>((props, ref) => (
    <MuiAlert {...props} ref={ref} />
));

const StyledAlert = styled(Alert, {
    shouldForwardProp: (prop) => prop !== "status",
})<{ status: AlertColor }>(({ theme, status }) => ({
    borderRadius: 24,
    color: "white",
    backgroundColor:
        theme.palette[status][status === "error" ? "main" : "dark"],
}));

const Message = (): JSX.Element => {
    const dispatch = useAppDispatch();

    const { text, status, open, redirectUrl } = useAppSelector(
        (state) => state.common.message
    );

    const click = () => {
        if (redirectUrl) window.location.href = redirectUrl;
    };

    const close = (e: Event | React.SyntheticEvent<any, Event>) => {
        e.stopPropagation();
        dispatch(closeMessage());
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={open}
            autoHideDuration={6000}
            onClose={close}
            {...(redirectUrl ? { onClick: click } : {})}
        >
            <StyledAlert
                onClose={close}
                status={status}
                severity={status}
                elevation={6}
                variant="filled"
            >
                {text}
            </StyledAlert>
        </Snackbar>
    );
};

export default Message;
